module.exports = __webpack_public_path__ + "static/media/u1F60E.bab980ae.webp";